//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mixinProps } from '@/components/mixin.js'
export default {
	name: 'Radio',
	mixins: [mixinProps],
	props: {
		value: {
			type: [String, Number],
			default() {
				return undefined
			}
		}
	},
	data() {
		return {
			name: ''
		}
	},
	computed: {
		checked() {
			return !!this.value && this.$parent.currentValue === this.value
		},
		dynamicClass() {
			return {
				'my-radio-checked': this.checked,
        'my-radio-disabled': this.disabled,
        'my-radio-unchecked': !this.checked,
			}
		}
	},
	created: function() {
		this.init()
	},
	methods: {
		init() {
			try {
				this.name = this.$parent.getRadioName()
			} catch (error) {
				console.error(error)
			}
		},
		change() {
			try {
				this.$parent.change(this.value)
			} catch (error) {
				console.error(error)
			}
		}
	}
}
